import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import PrimeVue from "primevue/config";
import axios from "axios";
import loader from "vue3-ui-preloader";
import "vue3-ui-preloader/dist/loader.css";
import "./assets/scss/style.css";
import VueGtag from "vue-gtag";

import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";

const app = createApp(App);
const pinia = createPinia();

function getSubdomainLink(subdomain, path) {
  const { port, protocol } = window.location;

  return `${protocol}//${subdomain ? `${subdomain}.` : ""}${import.meta.env.VITE_DOMAIN}${port ? `:${port}` : ""}${path}`;
}
app.config.globalProperties.$getSubdomainLink = getSubdomainLink;

axios.defaults.baseURL = import.meta.env.VITE_BASE_URL;
axios.defaults.headers.common["X-AUTH-TOKEN"] = import.meta.env.VITE_AUTH_TOKEN;

app.use(VueGtag, {
  config: { id: import.meta.env.VITE_GA_ID },
});
app.use(PrimeVue);
app.use(pinia);
app.use(router);
app.component("loader", loader);

import { useAuthStore } from "@/stores";

(async () => {
  const authStore = useAuthStore();
  await authStore.checkAuthStatus();
  app.mount("#app");
})();
